var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { BaseUserDto, UserType } from "./user.dtos";
import { IsEnum } from "class-validator";
export class ServiceProviderUserDto extends BaseUserDto {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], ServiceProviderUserDto.prototype, "type", void 0);
export class ServiceProviderUserForAuthenticationDto extends ServiceProviderUserDto {
}
export class InviteServiceProviderUserInput extends PickType(ServiceProviderUserDto, ["type", "email", "permissions", "onChainUser"]) {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
export class CreateServiceProviderUserInput extends OmitType(ServiceProviderUserDto, [
    "id",
    "organizationId",
    "onChainUser",
    "passwordExpiresAt",
    "passwordUpdatedAt",
    "loginFailureCount",
    "statusUntil",
    "accountStatus",
]) {
    constructor(fields) {
        super();
        Object.assign(this, fields);
    }
}
export class UpdateServiceProviderUserInput extends PartialType(CreateServiceProviderUserInput) {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], UpdateServiceProviderUserInput.prototype, "type", void 0);
